<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const i18nScope = 'components.sales_dashboard';

  // A summary tile's figure over the previous period, set under the tile's own
  // figure. The default slot takes the place of `figure` for a figure that is
  // not a single line, such as the revenue per currency.
  defineProps({
    figure: { type: String, default: null },
    // Lines read under the figure, such as the share it makes up
    details: { type: Array, default: () => [] }
  });
</script>

<template>
  <div class="border-top mt-2 pt-2">
    <p class="text-muted mb-0 small">{{ t(`${i18nScope}.previous_period`) }}</p>
    <slot>
      <p class="h6 mb-0">{{ figure }}</p>
    </slot>
    <p v-for="(detail, index) in details" :key="index" class="text-muted mb-0 small">{{ detail }}</p>
  </div>
</template>
